import { TablesInsert } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const createCrmProject = async (data: TablesInsert<'crm_project'> | TablesInsert<'crm_project'>[]) => {
    return await supabase.from("crm_project").insert(data).throwOnError().select().then(res => res.data);
}